import { object, string, number } from 'yup';

export const cellToClosetValidation = object().shape({
  title: number().typeError('שדה חובה').required('שדה חובה'),
  width: number().typeError('יש להזין מספרים בלבד'),
  height: number().typeError('יש להזין מספרים בלבד'),
  position: number().typeError('יש להזין מספרים בלבד').required('שדה חובה'),
});
